import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { authService } from '../services/authService';

const AdminProtectedRoute = () => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    // CRITICAL: Usar adminToken para el portal admin
    const token = localStorage.getItem('adminToken');
    const userStr = localStorage.getItem('adminUser');
    
    console.log('🔐 [ADMIN ROUTE] Verificando auth...', { hasToken: !!token, hasUser: !!userStr });
    
    if (!token) {
      console.log('❌ [ADMIN ROUTE] No hay adminToken');
      setLoading(false);
      return;
    }

    // Si ya tenemos el usuario guardado, verificar el rol directamente
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        console.log('👤 [ADMIN ROUTE] Usuario de localStorage:', user.email, user.role);
        
        if (user && user.role === 'super_admin') {
          setIsAuthenticated(true);
          setIsSuperAdmin(true);
          setLoading(false);
          return;
        }
      } catch (e) {
        console.error('Error parsing adminUser:', e);
      }
    }

    // Si no hay usuario guardado, verificar con el servidor
    try {
      const user = await authService.getMe();
      console.log('👤 [ADMIN ROUTE] Usuario del servidor:', user?.email, user?.role);
      
      if (user && user.role === 'super_admin') {
        setIsAuthenticated(true);
        setIsSuperAdmin(true);
        // Guardar el usuario para evitar llamadas futuras
        localStorage.setItem('adminUser', JSON.stringify(user));
      }
    } catch (error) {
      console.error('❌ [ADMIN ROUTE] Error checking auth:', error);
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gradient-to-br from-blue-500 to-blue-700">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-white text-lg">Verificando acceso...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !isSuperAdmin) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;
